<template>
    <div class="opportunity-panel">
        <div>
            <div class="container" v-if="!showProfileData">
                <div class="row mobile">
                    <div class="col-md-8">
                        <div class="title-button">
                            <h2>Painel de Oportunidades</h2>

                            <b-button variant="primary" size="sm" class="mb-2 icon-button" @click="openFilterModal">
                                <b-icon icon="funnel" aria-hidden="true"></b-icon> Filtrar
                            </b-button>
                        </div>

                        <div class="map">
                            <GoogleMap :listData="mapData" :zoom="4" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="quick-access">
                            <h6>Acesso rápido</h6>
                            <div>Clique em um dos cards para acessar.</div>

                            <div class="cards">
                                <div class="card radius-6">
                                    <div class="image">
                                        <img :src="require(`@/assets/people.svg`)" alt="people" />
                                    </div>

                                    <h5 class="quantity">{{ connectionsNumber }}</h5>

                                    <div>Conexões</div>
                                </div>

                                <div class="card radius-6">
                                    <div class="image">
                                        <StarsPPFix :starsFullNumber="getStarsNumber" />
                                    </div>

                                    <h5 class="quantity">{{ evaluationNumber }}</h5>

                                    <div>Avaliações</div>
                                </div>
                            </div>
                        </div>

                        <div class="my-connections">
                            <h6>Minhas conexões</h6>
                            <div>Clique em um dos cards para acessar.</div>

                            <div class="cards">
                                <div class="card radius-6">
                                    <div class="content">
                                        <h5 class="quantity">{{ investorsNumber }}</h5>
                                        <div>Investidores</div>
                                    </div>
                                </div>

                                <div class="card radius-6">
                                    <div class="content">
                                        <h5 class="quantity">{{ initiativesNumber }}</h5>
                                        <div>Iniciativas</div>
                                    </div>
                                </div>

                                <div class="card radius-6">
                                    <div class="content">
                                        <h5 class="quantity">{{ serviceProvisionNumber }}</h5>
                                        <div>Prestadores de serviço</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-data" v-if="showProfileData">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="back-btn font-14" @click="backFromSeeProfile()">Voltar</div>
                        </div>
                    </div>
                </div>

                <div>
                    <MyProfile
                        :profileData="getProfileData"
                        :profileTitle="getMyProfileTitle"
                        :isPending="true"
                        :isPlatform="true"
                        :isOutsideData="true"
                    />
                </div>
            </div>
        </div>

        <div class="cards-filter" v-if="false">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 card-col" v-for="(card, $index) in cardsFilter" :key="$index">
                        <div class="card radius-6">
                            <h5>{{ card.title }}</h5>
                            <div class="msg">{{ card.msg }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container" v-if="!showProfileData">
            <div id="connection-suggestions" class="connection-suggestions radius-6">
                <div class="title-button">
                    <h5 class="title">Sugestões de Conexão</h5>

                    <b-button
                        variant="primary"
                        size="sm"
                        class="mb-2 icon-button"
                        :disabled="!getAllowExport"
                        v-print="'#connection-suggestions'"
                    >
                        <b-icon icon="download" aria-hidden="true"></b-icon> Exportar
                    </b-button>
                </div>

                <div class="connections-cards">
                    <div class="row">
                        <div class="col-md-6 col-lg-4" :key="index" v-for="(item, index) in getConnections">
                            <ConnectionCardPP
                                :name="item.nome_organizacao"
                                :progress="item.compatibilidade"
                                :ods="item.ods"
                                :area="item.principal_area_atuacao"
                                :city="item.cidade && item.uf ? `${item.cidade} - ${item.uf}` : ''"
                                :showProgress="true"
                                :showStarsNumber="true"
                                :starsNumber="Math.round(item.estrela)"
                                :showImageId="true"
                                :urlLogo="item.url_logo"
                                :smallName="true"
                                :isOpportunity="true"
                            >
                                <template v-slot:footer-buttons>
                                    <b-button
                                        :variant="!getIsDarkTheme ? 'dark' : 'white'"
                                        @click="setShowProfileData(item)"
                                        >Ver mais</b-button
                                    >
                                </template>
                            </ConnectionCardPP>
                        </div>

                        <infinite-loading @infinite="infiniteHandler">
                            <div slot="spinner">
                                <b-spinner variant="info" label="Spinning"></b-spinner>
                            </div>
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                        </infinite-loading>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            ref="opportunity-modal-ref"
            title="Filtros"
            body-class="how-register-body-modal"
            ok-title="Filtrar"
            ok-variant="primary"
            cancel-title="Limpar filtros"
            cancel-variant="secondary"
            size="lg"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            @ok="filterData"
            @cancel="clearFilterDataLocalStorage"
        >
            <div class="accordion col-md-12" role="tablist">
                <b-card no-body class="mb-1" v-if="getAllowFilterData.PrimeirasInformacao">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 1">Primeiras Informações</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-1"
                        :visible="accordionActivated === 1"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Tipo de cadastro"
                                    label-for="register-type"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="register-type"
                                        name="register-type"
                                        v-model="filterForm.registerType.selected"
                                        :options="filterForm.registerType.options"
                                        @change="changeRegisterType"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Tipo de potência"
                                    label-for="power-type"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="power-type"
                                        name="power-type"
                                        v-model="filterForm.powerType.selected"
                                        :options="filterForm.powerType.options"
                                        :disabled="filterForm.registerType.selected !== 1"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Natureza da iniciativa"
                                    label-for="origin"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="origin"
                                        name="origin"
                                        v-model="filterForm.origin.selected"
                                        :options="filterForm.origin.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Iniciativa"
                                    label-for="initiative"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="initiative"
                                        name="initiative"
                                        v-model="filterForm.initiative.selected"
                                        :options="filterForm.initiative.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="ODS"
                                    label-for="ods"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="ods"
                                        name="ods"
                                        v-model="filterForm.ods.selected"
                                        value-field="item"
                                        text-field="text"
                                        :options="filterForm.ods.options"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Quais são as áreas de atuação da sua iniciativa?"
                                    label-for="areas"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="areas"
                                        name="areas"
                                        v-model="filterForm.areas.selected"
                                        :options="filterForm.areas.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group label="Estado" label-for="state" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="state"
                                        name="state"
                                        v-model="filterForm.state.selected"
                                        :options="filterForm.state.options"
                                        @change="changeState"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Cidade" label-for="city" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="city"
                                        name="city"
                                        v-model="filterForm.city.selected"
                                        :options="filterForm.city.options"
                                        :disabled="filterForm.city.options.length === 0"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Formato jurídico"
                                    label-for="legalConstitution"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="legalConstitution"
                                        name="legalConstitution"
                                        v-model="filterForm.legalConstitution.selected"
                                        :options="filterForm.legalConstitution.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Possui CNPJ" label-for="hasCnpj" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="hasCnpj"
                                        name="hasCnpj"
                                        v-model="filterForm.hasCnpj.selected"
                                        :options="filterForm.hasCnpj.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="false && getAllowFilterData.ResponsavelLegal">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 2"
                            >Sobre o Responsável Legal</b-button
                        >
                    </b-card-header>
                    <b-collapse
                        id="accordion-2"
                        :visible="accordionActivated === 2"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group label="Gênero" label-for="gender" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="gender"
                                        name="gender"
                                        v-model="filterForm.gender.selected"
                                        :options="filterForm.gender.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Há quanto tempo trabalha na iniciativa?"
                                    label-for="initiativeTime"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="initiativeTime"
                                        name="initiativeTime"
                                        v-model="filterForm.initiativeTime.selected"
                                        :options="filterForm.initiativeTime.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Cor/ Etnia" label-for="color" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="color"
                                        name="color"
                                        v-model="filterForm.color.selected"
                                        :options="filterForm.color.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Nível de escolaridade"
                                    label-for="scholarity"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="scholarity"
                                        name="scholarity"
                                        v-model="filterForm.scholarity.selected"
                                        :options="filterForm.scholarity.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="DRT (para artistas)"
                                    label-for="drt"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="drt"
                                        name="drt"
                                        v-model="filterForm.hasDrt.selected"
                                        :options="filterForm.hasDrt.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Tempo dedicado (%)"
                                    label-for="dedicatedTime"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="dedicatedTime"
                                        name="dedicatedTime"
                                        v-model="filterForm.dedicatedTime.selected"
                                        :options="filterForm.dedicatedTime.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Já empreendeu antes?"
                                    label-for="undertookBefore"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="undertookBefore"
                                        name="undertookBefore"
                                        v-model="filterForm.undertookBefore.selected"
                                        :options="filterForm.undertookBefore.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Você é:" label-for="profession" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="profession"
                                        name="profession"
                                        v-model="filterForm.profession.selected"
                                        :options="filterForm.profession.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.SobreOrganizacao">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 3">Sobre a Iniciativa</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-3"
                        :visible="accordionActivated === 3"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Insira o ano de fundação. (AAAA)"
                                    label-for="initiativeYearCreated"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-input
                                        id="initiativeYearCreated"
                                        name="initiativeYearCreated"
                                        v-model="filterForm.initiativeYearCreated"
                                        v-mask="'####'"
                                        type="text"
                                        placeholder="Digite aqui"
                                    ></b-form-input>

                                    <div
                                        class="invalid"
                                        v-if="
                                            filterForm.initiativeYearCreated &&
                                                filterForm.initiativeYearCreated.length < 4
                                        "
                                    >
                                        Deve inserir 4 caracteres
                                    </div>
                                </b-form-group>

                                <b-form-group
                                    label="Área de abrangência"
                                    label-for="area"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="area"
                                        name="area"
                                        v-model="filterForm.area.selected"
                                        :options="filterForm.area.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Público motivador"
                                    label-for="agePublic"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="agePublic"
                                        name="agePublic"
                                        v-model="filterForm.agePublic.selected"
                                        :options="filterForm.agePublic.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Bioma" label-for="biome" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="biome"
                                        name="biome"
                                        v-model="filterForm.biome.selected"
                                        :options="filterForm.biome.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Iniciativa inovadora"
                                    label-for="isInnovative"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="isInnovative"
                                        name="isInnovative"
                                        v-model="filterForm.isInnovative.selected"
                                        :options="filterForm.isInnovative.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Qual é o atual estágio de maturidade da sua iniciativa?"
                                    label-for="maturityStage"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="maturityStage"
                                        name="maturityStage"
                                        v-model="filterForm.maturityStage.selected"
                                        :options="filterForm.maturityStage.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Estágio de desenvolvimento"
                                    label-for="developmentStage"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="developmentStage"
                                        name="developmentStage"
                                        v-model="filterForm.developmentStage.selected"
                                        :options="filterForm.developmentStage.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="% de mulheres na equipe"
                                    label-for="womenQuantity"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="womenQuantity"
                                        name="womenQuantity"
                                        v-model="filterForm.womenQuantity.selected"
                                        :options="filterForm.womenQuantity.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Ligação política"
                                    label-for="politicalConnection"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="politicalConnection"
                                        name="politicalConnection"
                                        v-model="filterForm.politicalConnection.selected"
                                        :options="filterForm.politicalConnection.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Passou por aceleração"
                                    label-for="hadAcceleration"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hadAcceleration"
                                        name="hadAcceleration"
                                        v-model="filterForm.hadAcceleration.selected"
                                        :options="filterForm.hadAcceleration.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Ligação a igreja"
                                    label-for="churchConnection"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="churchConnection"
                                        name="churchConnection"
                                        v-model="filterForm.churchConnection.selected"
                                        :options="filterForm.churchConnection.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Atualmente sua iniciativa é:"
                                    label-for="currentInitiativeStatus"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="currentInitiativeStatus"
                                        name="currentInitiativeStatus"
                                        v-model="filterForm.currentInitiativeStatus.selected"
                                        :options="filterForm.currentInitiativeStatus.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group label="Distrito" label-for="district" class="col-md-6 ask-label-filter">
                                    <b-form-select
                                        id="district"
                                        name="district"
                                        v-model="filterForm.district.selected"
                                        :options="filterForm.district.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Categoria de financiador(e)"
                                    label-for="financierCategory"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="financierCategory"
                                        name="financierCategory"
                                        v-model="filterForm.financierCategory.selected"
                                        :options="filterForm.financierCategory.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Colaboradores"
                                    label-for="employeesNumber"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="employeesNumber"
                                        name="employeesNumber"
                                        v-model="filterForm.employeesNumber.selected"
                                        :options="filterForm.employeesNumber.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="De que maneira sua organização apoia as potências periféricas? (marque todas que se aplicam)"
                                    label-for="supportWays"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="supportWays"
                                        name="supportWays"
                                        v-model="filterForm.supportWays.selected"
                                        :options="filterForm.supportWays.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Em quais leis de incentivo sua iniciativa tem projetos aprovados?"
                                    label-for="laws"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="laws"
                                        name="laws"
                                        v-model="filterForm.laws.selected"
                                        :options="filterForm.laws.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Projetos aprovados por qual lei de incentivo sua iniciativa apoia?"
                                    label-for="approvedProjects"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="approvedProjects"
                                        name="approvedProjects"
                                        v-model="filterForm.approvedProjects.selected"
                                        :options="filterForm.approvedProjects.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Quais tipos de iniciativas sociais você apoia? (marque todas que se aplicam)"
                                    label-for="socialInitiativeTypes"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="socialInitiativeTypes"
                                        name="socialInitiativeTypes"
                                        v-model="filterForm.socialInitiativeTypes.selected"
                                        :options="filterForm.socialInitiativeTypes.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Faixa de aporte financeiro"
                                    label-for="financialContributionRange"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="financialContributionRange"
                                        name="financialContributionRange"
                                        v-model="filterForm.financialContributionRange.selected"
                                        :options="filterForm.financialContributionRange.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Acesso a apoio via"
                                    label-for="ways"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="ways"
                                        name="ways"
                                        v-model="filterForm.ways.selected"
                                        :options="filterForm.ways.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Documentos que possui/exige"
                                    label-for="documents"
                                    class="col-md-12 all-width ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="documents"
                                        name="documents"
                                        v-model="filterForm.documents.selected"
                                        :options="filterForm.documents.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Qual a dimensão que melhor descreve o impacto social produzido pela sua iniciativa?"
                                    label-for="socialImpact"
                                    class="col-md-12 ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="socialImpact"
                                        name="socialImpact"
                                        v-model="filterForm.socialImpact.selected"
                                        :options="filterForm.socialImpact.options"
                                        value-field="item"
                                        text-field="text"
                                        stacked
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Indique se sua iniciativa possui algum título ou qualificação e qual"
                                    label-for="titleQualification"
                                    class="col-md-12 ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="title-qualification"
                                        name="titleQualification"
                                        v-model="filterForm.titleQualification.selected"
                                        :options="filterForm.titleQualification.options"
                                        value-field="item"
                                        text-field="text"
                                        stacked
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Segmento de mercado"
                                    label-for="marketSegments"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="market-segments"
                                        name="marketSegments"
                                        v-model="filterForm.marketSegments.selected"
                                        :options="filterForm.marketSegments.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Qual o tipo do seu produto?"
                                    label-for="productType"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="product-type"
                                        name="productType"
                                        v-model="filterForm.productType.selected"
                                        :options="filterForm.productType.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Qual o tipo do seu serviço?"
                                    label-for="serviceType"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="service-type"
                                        name="serviceType"
                                        v-model="filterForm.serviceType.selected"
                                        :options="filterForm.serviceType.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="No caso de aporte financeiro, sua iniciativa apoia (marque todas que se aplicam)"
                                    label-for="financialSupport"
                                    class="col-md-12 required ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        name="financialSupport"
                                        v-model="filterForm.financialSupport.selected"
                                        :options="filterForm.financialSupport.options"
                                        value-field="item"
                                        text-field="text"
                                        stacked
                                    ></b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.PlanejamentoGestao">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 4">Planejamento e Gestão</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-4"
                        :visible="accordionActivated === 4"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Possui planejamento estratégico"
                                    label-for="hasProcess"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasProcess"
                                        name="hasProcess"
                                        v-model="filterForm.hasProcess.selected"
                                        :options="filterForm.hasProcess.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Possui missão definida"
                                    label-for="hasMission"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasMission"
                                        name="hasMission"
                                        v-model="filterForm.hasMission.selected"
                                        :options="filterForm.hasMission.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Possui equipe de comunicação"
                                    label-for="hasTeam"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasTeam"
                                        name="hasTeam"
                                        v-model="filterForm.hasTeam.selected"
                                        :options="filterForm.hasTeam.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Possui visão definida"
                                    label-for="hasVision"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasVision"
                                        name="hasVision"
                                        v-model="filterForm.hasVision.selected"
                                        :options="filterForm.hasVision.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Possui valores definidos"
                                    label-for="hasValues"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasValues"
                                        name="hasValues"
                                        v-model="filterForm.hasValues.selected"
                                        :options="filterForm.hasValues.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Indicar possibilidade de respostas"
                                    label-for="initiativeHas"
                                    class="col-md-12 ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="initiative-has"
                                        name="initiativeHas"
                                        v-model="filterForm.initiativeHas.selected"
                                        :options="filterForm.initiativeHas.options"
                                        value-field="item"
                                        text-field="text"
                                        stracked
                                    ></b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.SustentabilidadeFinanceira">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 5"
                            >Sustentabilidade Financeira</b-button
                        >
                    </b-card-header>
                    <b-collapse
                        id="accordion-5"
                        :visible="accordionActivated === 5"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Orçamento anual da sua iniciativa"
                                    label-for="budget"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="budget"
                                        name="budget"
                                        v-model="filterForm.budget.selected"
                                        :options="filterForm.budget.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Como a iniciativa se mantém"
                                    label-for="financiallyMaintain"
                                    class="col-md-12 division-col ask-label-filter"
                                >
                                    <b-form-checkbox-group
                                        id="financiallyMaintain"
                                        name="financiallyMaintain"
                                        v-model="filterForm.financiallyMaintain.selected"
                                        :options="filterForm.financiallyMaintain.options"
                                        value-field="item"
                                        text-field="text"
                                    ></b-form-checkbox-group>
                                </b-form-group>

                                <b-form-group
                                    label="Possui contador"
                                    label-for="hasCounter"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasCounter"
                                        name="hasCounter"
                                        v-model="filterForm.hasCounter.selected"
                                        :options="filterForm.hasCounter.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Tem fundo de reserva"
                                    label-for="reserveFund"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="reserveFund"
                                        name="reserveFund"
                                        v-model="filterForm.reserveFund.selected"
                                        :options="filterForm.reserveFund.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Tem equipe para captação de recursos"
                                    label-for="hasFundRaising"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasFundRaising"
                                        name="hasFundRaising"
                                        v-model="filterForm.hasFundRaising.selected"
                                        :options="filterForm.hasFundRaising.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Duração do fundo de reserva"
                                    label-for="hasFundTime"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasFundTime"
                                        name="hasFundTime"
                                        v-model="filterForm.hasFundTime.selected"
                                        :options="filterForm.hasFundTime.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Existe endividamento"
                                    label-for="hasDebts"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasDebts"
                                        name="hasDebts"
                                        v-model="filterForm.hasDebts.selected"
                                        :options="filterForm.hasDebts.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Faturamento mensal da sua iniciativa"
                                    label-for="monthlyInvoicing"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="monthlyInvoicing"
                                        name="monthlyInvoicing"
                                        v-model="filterForm.monthlyInvoicing.selected"
                                        :options="filterForm.monthlyInvoicing.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.RedesParceiro">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 6">Redes e Parceiros</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-6"
                        :visible="accordionActivated === 6"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Iniciativa atua em parceria"
                                    label-for="currentPartners"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="currentPartners"
                                        name="currentPartners"
                                        v-model="filterForm.currentPartners.selected"
                                        :options="filterForm.currentPartners.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Iniciativa faz parte de rede e/ou fórum"
                                    label-for="currentNetworks"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="currentNetworks"
                                        name="currentNetworks"
                                        v-model="filterForm.currentNetworks.selected"
                                        :options="filterForm.currentNetworks.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.ResultadoImpacto">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 7">Resultados e Impactos</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-7"
                        :visible="accordionActivated === 7"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Monitoramento e avaliação sistematizados"
                                    label-for="hasMonitoringProcess"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasMonitoringProcess"
                                        name="hasMonitoringProcess"
                                        v-model="filterForm.hasMonitoringProcess.selected"
                                        :options="filterForm.hasMonitoringProcess.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Possui indicadores de desempenho"
                                    label-for="hasPerformanceIndications"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasPerformanceIndications"
                                        name="hasPerformanceIndications"
                                        v-model="filterForm.hasPerformanceIndications.selected"
                                        :options="filterForm.hasPerformanceIndications.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="getAllowFilterData.Governanca">
                    <b-card-header header-tag="header" role="tab">
                        <b-button block variant="info" @click="accordionActivated = 8">Governança</b-button>
                    </b-card-header>
                    <b-collapse
                        id="accordion-8"
                        :visible="accordionActivated === 8"
                        accordion="my-accordion"
                        role="tabpanel"
                    >
                        <b-card-body>
                            <div class="row">
                                <b-form-group
                                    label="Possui estatuto"
                                    label-for="isContemplatedMission"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="isContemplatedMission"
                                        name="isContemplatedMission"
                                        v-model="filterForm.isContemplatedMission.selected"
                                        :options="filterForm.isContemplatedMission.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="A iniciativa passa por auditoria?"
                                    label-for="hasAudit"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasAudit"
                                        name="hasAudit"
                                        v-model="filterForm.hasAudit.selected"
                                        :options="filterForm.hasAudit.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Há um conselho deliberativo?"
                                    label-for="hasCouncil"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasCouncil"
                                        name="hasCouncil"
                                        v-model="filterForm.hasCouncil.selected"
                                        :options="filterForm.hasCouncil.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Conselho fiscal estabelecido?"
                                    label-for="hasFiscalCouncil"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasFiscalCouncil"
                                        name="hasFiscalCouncil"
                                        v-model="filterForm.hasFiscalCouncil.selected"
                                        :options="filterForm.hasFiscalCouncil.options"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group
                                    label="Mantém registro das atividades financeiras e econômicas?"
                                    label-for="hasRegister"
                                    class="col-md-6 ask-label-filter"
                                >
                                    <b-form-select
                                        id="hasRegister"
                                        name="hasRegister"
                                        v-model="filterForm.hasRegister.selected"
                                        :options="filterForm.hasRegister.options"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import GoogleMap from '@/ui/google-map/GoogleMap'
import { PlatformApi } from '../../../../api/platform'
import InfiniteLoading from 'vue-infinite-loading'
import ConnectionCardPP from '@/ui/connection-card-pp/ConnectionCardPP'
import StarsPP from '@/ui/stars-pp/StarsPP'
import StarsPPFix from '@/ui/stars-pp/StarsPPFix'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import RegisterFirstInformationApi from '@/api/register-first-information/RegisterFirstInformationApi'
import { AboutLegalGuardianApi } from '../../../../api/register-about-legal-guardian'
import { AboutInitiativeApi } from '../../../../api/about-initiative'
import { FinancialSustainabilityApi } from '../../../../api/financial-sustainability'
import { AuthenticationApi } from '../../../../api/authentication'
import MyProfile from '@/components/my-profile/MyProfile'

const authenticationApi = new AuthenticationApi()
const platformApi = new PlatformApi()
const registerFirstInformationApi = new RegisterFirstInformationApi()
const aboutLegalGuardianApi = new AboutLegalGuardianApi()
const aboutInitiativeApi = new AboutInitiativeApi()
const financialSustainabilityApi = new FinancialSustainabilityApi()

export default {
    components: { GoogleMap, InfiniteLoading, ConnectionCardPP, StarsPP, DangerModalPP, MyProfile, StarsPPFix },
    data() {
        return {
            message: null,
            idUserLogged: null,
            profileData: {},
            showProfileData: false,
            starsNumber: 0,
            evaluationNumber: 0,
            myProfileTitle: '',
            connectionsNumber: 0,
            investorsNumber: 50,
            initiativesNumber: 25,
            serviceProvisionNumber: 25,
            accordionActivated: 1,
            connections: [],
            allConnections: [],
            mapDataAll: [],
            mapData: [],
            filterDataIds: null,
            page: 0,
            allowFilterData: {
                PrimeirasInformacao: false,
                ResponsavelLegal: false,
                SobreOrganizacao: false,
                PlanejamentoGestao: false,
                SustentabilidadeFinanceira: false,
                RedesParceiro: false,
                ResultadoImpacto: false,
                Governanca: false,
                Anexos: false
            },
            cardsFilter: [
                {
                    title: 'CNPJ',
                    msg: 'Se você retirar o filtro de CNPJ sua busca aumenta em 500 iniciativas'
                },
                {
                    title: 'AUDITORIA',
                    msg: 'Se você retirar o filtro de AUDITORIA sua busca aumenta em 2.000 iniciativas'
                },
                {
                    title: 'TEMPO DE EXISTÊNCIA',
                    msg: 'Se você diminuir o filtro de TEMPO DE EXISTÊNCIA sua busca aumenta em 1.000 iniciativas'
                }
            ],
            filterForm: {
                registerType: {
                    selected: null,
                    options: []
                },
                powerType: {
                    selected: null,
                    options: [
                        { value: null, text: 'Selecione' },
                        { value: 1, text: 'Prestador de Serviço' },
                        { value: 0, text: 'Potência' }
                    ]
                },
                legalConstitution: {
                    selected: null,
                    options: []
                },
                hasCnpj: {
                    selected: null,
                    options: []
                },
                gender: {
                    selected: null,
                    options: []
                },
                initiativeTime: {
                    selected: null,
                    options: []
                },
                color: {
                    selected: null,
                    options: []
                },
                scholarity: {
                    selected: null,
                    options: []
                },
                hasDrt: {
                    selected: null,
                    options: [
                        { value: null, text: 'Selecione' },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                undertookBefore: {
                    selected: null,
                    options: [
                        { value: null, text: 'Selecione' },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                dedicatedTime: {
                    selected: null,
                    options: []
                },
                ods: {
                    selected: [],
                    options: [
                        { text: 'Erradicação da Pobreza', item: 1, value: 1 },
                        { text: 'Redução das Desigualdades', item: 10, value: 10 },
                        { text: 'Fome Zero e Agricultura Sustentável', item: 2, value: 2 },
                        { text: 'Cidades e Comunidades Sustentáveis', item: 11, value: 11 },
                        { text: 'Saúde e Bem-Estar', item: 3, value: 3 },
                        { text: 'Consumo e Produção Responsáveis', item: 12, value: 12 },
                        { text: 'Educação de Qualidade', item: 4, value: 4 },
                        { text: 'Ação Contra a Mudança Global do Clima', item: 13, value: 13 },
                        { text: 'Igualdade de Gênero', item: 5, value: 5 },
                        { text: 'Vida na Água', item: 14, value: 14 },
                        { text: 'Água Potável e Saneamento', item: 6, value: 6 },
                        { text: 'Vida Terrestre', item: 15, value: 15 },
                        { text: 'Energia Limpa e Acessível', item: 7, value: 7 },
                        { text: 'Paz, Justiça e Instituições Eficazes', item: 16, value: 16 },
                        { text: 'Trabalho Decente e Crescimento Econômico', item: 8, value: 8 },
                        { text: 'Parcerias e Meios de Implementação', item: 17, value: 17 },
                        { text: 'Indústria, Inovação e Infraestrutura', item: 9, value: 9 }
                    ]
                },
                areas: {
                    selected: [],
                    options: [
                        { text: 'Ações Afirmativas: raça, gênero e protagonismo jovem', item: 1, value: 1 },
                        { text: 'Esporte & Saúde', item: 2, value: 2 },
                        { text: 'Advocacy & Incidência Política', item: 3, value: 3 },
                        { text: 'Habitação', item: 4, value: 4 },
                        { text: 'Arte & Cultura', item: 5, value: 5 },
                        { text: 'Inclusão Digital', item: 6, value: 6 },
                        { text: 'Assistência Social', item: 7, value: 7 },
                        {
                            text:
                                'Inclusão Produtiva (empreendedorismo, empregabilidade e capacitação para o mercado de trabalho, geração de trabalho e renda)',
                            item: 8,
                            value: 8
                        },
                        { text: 'Bem Viver & Qualidade de Vida', item: 9, value: 9 },
                        { text: 'Comunicação & Marketing', item: 10, value: 10 },
                        { text: 'Justiça Racial', item: 11, value: 11 },
                        { text: 'Defesa de direitos da população LGBTQIAP+', item: 12, value: 12 },
                        { text: 'Meio ambiente / Sustentabilidade', item: 13, value: 13 },
                        { text: 'Defesa de direitos da população negra', item: 14, value: 14 },
                        { text: 'Mobilidade Urbana', item: 15, value: 15 },
                        { text: 'Defesa de direitos das mulheres', item: 16, value: 16 },
                        { text: 'Paz & Justiça', item: 17, value: 17 },
                        { text: 'Defesa de direitos dos povos indígenas', item: 18, value: 18 },
                        { text: 'PCD (Pessoas com Deficiência)', item: 19, value: 19 },
                        { text: 'Desenvolvimento Comunitário', item: 20, value: 20 },
                        { text: 'Pesquisa / Produção de Conhecimento', item: 21, value: 21 },
                        { text: 'Direito dos Animais', item: 22, value: 22 },
                        { text: 'Refugiados', item: 23, value: 23 },
                        { text: 'Direitos humanos, justiça social e cidadania', item: 24, value: 24 },
                        { text: 'Saúde', item: 25, value: 25 },
                        { text: 'Economia criativa e solidária', item: 26, value: 26 },
                        { text: 'Tecnologias Sociais', item: 27, value: 27 },
                        { text: 'Educação', item: 28, value: 28 },
                        { text: 'Outro (especifique)', item: 29, value: 29 }
                    ]
                },
                titleQualification: {
                    selected: [],
                    options: [
                        {
                            text: 'OSCIP - Organização da Sociedade Civil de Interesse Público',
                            item: 1,
                            value: 1,
                            show: true
                        },
                        { text: 'UPF - Utilidade Pública Federal', item: 2, value: 2, show: true },
                        { text: 'UPE - Utilidade Pública Estadual', item: 3, value: 3, show: true },
                        { text: 'UPM - Utilidade Pública Municipal', item: 4, value: 4, show: true },
                        {
                            text: 'CEBAS – Certificado de Entidade Beneficente de Assistência Social',
                            item: 5,
                            value: 5,
                            show: true
                        },
                        {
                            text: 'Inscrição no CMAS – Conselho Municipal de Assistência Social',
                            item: 6,
                            value: 6,
                            show: true
                        },
                        {
                            text: 'Inscrição no CNAS – Conselho Nacional de Assistência Social',
                            item: 7,
                            value: 7,
                            show: true
                        },
                        {
                            text:
                                'Inscrição nos Conselhos de Direito Específico: Direitos da Criança e do Adolescente; de Saúde, do Idoso, da Pessoa com Deficiência, outros',
                            item: 8,
                            value: 8,
                            show: true
                        },
                        { text: 'Outros', item: 9, value: 9, show: true },
                        { text: 'Não se aplica', item: 10, value: 10, show: true }
                    ]
                },
                marketSegments: {
                    selected: [],
                    options: [
                        { text: 'Acessibilidade e Inclusão', item: 1, value: 1 },
                        { text: 'Governo', item: 2, value: 2 },
                        { text: 'Agricultura', item: 3, value: 3 },
                        { text: 'Literatura', item: 4, value: 4 },
                        { text: 'Água e Saneamento', item: 5, value: 5 },
                        { text: 'Loja (varejo)', item: 6, value: 6 },
                        { text: 'Alimentação e Nutrição', item: 7, value: 7 },
                        { text: 'Longevidade', item: 8, value: 8 },
                        { text: 'Artesanato', item: 9, value: 9 },
                        { text: 'Meio Ambiente e Sustentabilidade', item: 10, value: 10 },
                        { text: 'Audiovisual', item: 11, value: 11 },
                        { text: 'Moda', item: 12, value: 12 },
                        { text: 'Cidades: Mobilidade, Habitação e Transporte', item: 13, value: 13 },
                        { text: 'Prestação de serviço', item: 14, value: 14 },
                        { text: 'Cidadania (Cultura, Esporte e Advocacy)', item: 15, value: 15 },
                        { text: 'Produtos e Serviços Financeiros', item: 16, value: 16 },
                        { text: 'Reforma', item: 17, value: 17 },
                        { text: 'Ciência', item: 18, value: 18 },
                        { text: 'Resíduos e Permacultura', item: 19, value: 19 },
                        { text: 'Combate a Desigualdade', item: 20, value: 20 },
                        { text: 'Salão de Beleza', item: 21, value: 21 },
                        { text: 'Comunicação e Jornalismo', item: 22, value: 22 },
                        { text: 'Saúde e Bem-estar', item: 23, value: 23 },
                        { text: 'Direitos Humanos', item: 24, value: 24 },
                        { text: 'Suporte ao Empreendedorismo', item: 25, value: 25 },
                        { text: 'Educação e Formação', item: 26, value: 26 },
                        { text: 'Tecnologia', item: 27, value: 27 },
                        { text: 'Empregabilidade e Geração de Renda', item: 28, value: 28 },
                        { text: 'Turismo e Ecoturismo', item: 29, value: 29 },
                        { text: 'Energia', item: 30, value: 30 },
                        { text: 'Outros (especifique)', item: 31, value: 31 }
                    ]
                },
                productType: {
                    selected: [],
                    options: [
                        { text: 'Alimentos', item: 1, value: 1 },
                        { text: 'Comunicação', item: 2, value: 2 },
                        { text: 'Produtos de Higiene', item: 3, value: 3 },
                        { text: 'Vestuário', item: 4, value: 4 },
                        { text: 'Outros (especifique)', item: 5, value: 5 }
                    ]
                },
                serviceType: {
                    selected: [],
                    options: [
                        { text: 'Audiovisual', item: 1, value: 1 },
                        { text: 'Cabeleleiro', item: 2, value: 2 },
                        { text: 'Comunicação', item: 3, value: 3 },
                        { text: 'Consultoria', item: 4, value: 4 },
                        { text: 'Contabilidade', item: 5, value: 5 },
                        { text: 'Jurídico', item: 6, value: 6 },
                        { text: 'Logístico', item: 7, value: 7 },
                        { text: 'Marcineiro', item: 8, value: 8 },
                        { text: 'Produção de Eventos', item: 9, value: 9 },
                        { text: 'Outros (especifique)', item: 10, value: 10 }
                    ]
                },
                financialSupport: {
                    selected: [],
                    options: [
                        { text: 'Ajuda de custo', item: 1, value: 1 },
                        { text: 'Estabelecimento de Endowment (Fundo Patrimonial)', item: 2, value: 2 },
                        { text: 'Aluguel de Salas, Água, Luz, Internet, Domínio & Hospedagem', item: 3, value: 3 },
                        { text: 'Eventos', item: 4, value: 4 },
                        { text: 'Aquisição de Bens Imóveis', item: 5, value: 5 },
                        { text: 'Fomento de Redes', item: 6, value: 6 },
                        { text: 'Aquisição de Bens Móveis (Materiais/Equipamentos, etc)', item: 7, value: 7 },
                        { text: 'Obras/Reformas', item: 8, value: 8 },
                        { text: 'Bolsa de estudo', item: 9, value: 9 },
                        { text: 'Pagamento a Prestadores de Serviço com Vínculo Familiar', item: 10, value: 10 },
                        { text: 'Campanhas', item: 11, value: 11 },
                        { text: 'Pagamento de Recursos Humanos', item: 12, value: 12 },
                        { text: 'Capacitações', item: 13, value: 13 },
                        { text: 'Pagamento de Terceirizados', item: 14, value: 14 },
                        { text: 'Compra de ações, debêntures ou outros valores imobiliários', item: 15, value: 15 },
                        { text: 'Pesquisas & Diagnósticos', item: 16, value: 16 },
                        { text: 'Compra de Alimentos', item: 17, value: 17 },
                        { text: 'Projetos', item: 18, value: 18 },
                        { text: 'Congressos', item: 19, value: 19 },
                        { text: 'Publicações', item: 20, value: 20 },
                        { text: 'Constituição de Fluxo de Caixa', item: 21, value: 21 },
                        {
                            text: 'Publicidade (salvo as de caráter educativo, informativo ou de orientação social)',
                            item: 22,
                            value: 22
                        },
                        { text: 'Consultorias para Estudos & Projetos', item: 23, value: 23 },
                        { text: 'Taxas Bancárias, Multas, Juros & Impostos', item: 24, value: 24 },
                        { text: 'Dívidas', item: 25, value: 26 },
                        { text: 'Viagens', item: 26, value: 26 },
                        { text: 'Outros (especifique)', item: 27, value: 27 }
                    ]
                },
                supportWays: {
                    selected: [],
                    options: [
                        { text: 'Financeiramente', item: 1, value: 1 },
                        { text: 'Redes e Conexões', item: 2, value: 2 },
                        { text: 'Aceleração', item: 3, value: 3 },
                        { text: 'Compra de Produtos', item: 4, value: 4 },
                        { text: 'Capacitação', item: 5, value: 5 },
                        { text: 'Pesquisa', item: 6, value: 6 },
                        { text: 'Planejamento Estratégico', item: 7, value: 7 },
                        { text: 'Doação de bens móveis e imóveis', item: 8, value: 8 },
                        { text: 'Contratação de Serviços', item: 9, value: 9 },
                        { text: 'Voluntariado Pró Bono', item: 10, value: 10 }
                    ]
                },
                laws: {
                    selected: [],
                    options: [
                        { text: 'Lei Rouanet', item: 1, value: 1 },
                        { text: 'Lei do Audiovisual', item: 2, value: 2 },
                        { text: 'Programa de Ação Cultural', item: 3, value: 3 },
                        { text: 'Lei de Incentivo ao Esporte', item: 4, value: 4 },
                        { text: 'PRONON - Programa Nacional de Oncologia', item: 5, value: 5 },
                        { text: 'PRONAS - Programa Nacional de Acessibilidade', item: 6, value: 6 },
                        { text: 'FIA – Fundo dos Direitos da Criança e do Adolescente', item: 7, value: 7 },
                        { text: 'Fundo Municipal do Idoso', item: 8, value: 8 },
                        { text: 'PROAC', item: 9, value: 9 },
                        { text: 'PROMAC', item: 10, value: 10 },
                        { text: 'Outros (especifique)', item: 11, value: 11 }
                    ]
                },
                approvedProjects: {
                    selected: [],
                    options: [
                        { text: 'Lei Rouanet', item: 1, value: 1 },
                        { text: 'Lei do Audiovisual', item: 2, value: 2 },
                        { text: 'Programa de Ação Cultural', item: 3, value: 3 },
                        { text: 'Lei de Incentivo ao Esporte', item: 4, value: 4 },
                        { text: 'PRONON - Programa Nacional de Oncologia', item: 5, value: 5 },
                        { text: 'PRONAS - Programa Nacional de Acessibilidade', item: 6, value: 6 },
                        { text: 'FIA – Fundo dos Direitos da Criança e do Adolescente', item: 7, value: 7 },
                        { text: 'Fundo Municipal do Idoso', item: 8, value: 8 },
                        { text: 'PROAC', item: 9, value: 9 },
                        { text: 'PROMAC', item: 10, value: 10 },
                        { text: 'Outros (especifique)', item: 11, value: 11 }
                    ]
                },
                initiativeHas: {
                    selected: [],
                    options: [
                        {
                            text:
                                'Levantamentos diagnósticos e análises da realidade local realizado por profissional especializado',
                            item: 1,
                            value: 1
                        },
                        {
                            text:
                                'Parceria com universidades ou instituições especializadas na área de atuação de sua organização',
                            item: 2,
                            value: 2
                        },
                        { text: 'Teoria da Mudança', item: 3, value: 3 },
                        {
                            text: 'Avaliação de impacto com profissional ou instituição especializada',
                            item: 4,
                            value: 4
                        },
                        { text: 'Não se aplica', item: 5, value: 5 }
                    ]
                },
                state: {
                    selected: null,
                    options: []
                },
                city: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                area: {
                    selected: null,
                    options: []
                },
                agePublic: {
                    selected: null,
                    options: []
                },
                biome: {
                    selected: null,
                    options: []
                },
                isInnovative: {
                    selected: null,
                    options: []
                },
                developmentStage: {
                    selected: null,
                    options: []
                },
                womenQuantity: {
                    selected: null,
                    options: []
                },
                politicalConnection: {
                    selected: null,
                    options: []
                },
                hadAcceleration: {
                    selected: null,
                    options: []
                },
                churchConnection: {
                    selected: null,
                    options: []
                },
                district: {
                    selected: null,
                    options: []
                },
                financierCategory: {
                    selected: null,
                    options: []
                },
                employeesNumber: {
                    selected: null,
                    options: []
                },
                socialInitiativeTypes: {
                    selected: [],
                    options: [
                        { text: 'Coletivo (sem CNPJ)', item: 1, value: 1 },
                        { text: 'Liderança comunitária (Pessoa Física)', item: 2, value: 2 },
                        { text: 'Empreendedor (MEI)', item: 3, value: 3 },
                        { text: 'Movimento', item: 4, value: 4 },
                        { text: 'Empresa', item: 5, value: 5 },
                        { text: 'Negócio Social / Impacto', item: 6, value: 6 },
                        { text: 'Escola (pública ou particular)', item: 7, value: 7 },
                        { text: 'OSCs / ONGs / Entidades (com CNPJ)', item: 8, value: 8 },
                        { text: 'Hospitais / Centro Clínico ou Terapêutico', item: 9, value: 9 },
                        { text: 'Partido Político', item: 10, value: 10 },
                        { text: 'Instituição do Sistema “S” (Senai, Senac, Sesi, Sebrae, Sesc)', item: 11, value: 11 },
                        { text: 'Rede', item: 12, value: 12 },
                        { text: 'Instituição Religiosa', item: 13, value: 13 },
                        { text: 'Universidade ou Autarquia', item: 14, value: 14 },
                        { text: 'Sindicato', item: 15, value: 15 },
                        { text: 'Outros', item: 16, value: 16 }
                    ]
                },
                financialContributionRange: {
                    selected: [],
                    options: [
                        { text: 'Até 10 mil reais', item: 1, value: 1 },
                        { text: 'Entre 10 e 20 mil reais', item: 2, value: 2 },
                        { text: 'Entre 20 e 50 mil reais', item: 3, value: 3 },
                        { text: 'Entre 50 e 100 mil reais', item: 4, value: 4 },
                        { text: 'Entre 100 e 500 mil reais', item: 5, value: 5 },
                        { text: 'Mais de 500 mil reais', item: 6, value: 6 }
                    ]
                },
                ways: {
                    selected: [],
                    options: [
                        { text: 'Por edital', item: 1, value: 1 },
                        { text: 'Via leis de incentivo', item: 2, value: 2 },
                        { text: 'Por e-mail', item: 3, value: 3 },
                        { text: 'Por recomendação', item: 4, value: 4 },
                        { text: 'Outros (especifique)', item: 5, value: 5 }
                    ]
                },
                documents: {
                    selected: [],
                    options: [
                        { text: 'Ata de Eleição da Atual Diretoria', item: 1, value: 1 },
                        { text: 'Ata de Fundação da organização e última atualização', item: 2, value: 2 },
                        { text: 'Auditoria externa', item: 3, value: 3 },
                        { text: 'Balanço Patrimonial do último exercício social', item: 4, value: 4 },
                        {
                            text:
                                'Carta elaborada e assinada pela potência, atestando que as atividades por ela desenvolvidas estão de acordo com as leis trabalhistas brasileiras',
                            item: 5,
                            value: 5
                        },
                        {
                            text:
                                'Certidão Conjunta de Débitos relativos aos Tributos Federais, Certidões negativa de débito trabalhista (CNDT) e regularidade com o FGTS',
                            item: 6,
                            value: 6
                        },
                        {
                            text: 'Certidão de isenção do Imposto de Transmissão Causa Mortis e Doação (ITCMD)',
                            item: 7,
                            value: 7
                        },
                        {
                            text:
                                'Certidões negativas de débitos fiscais (CND) nos âmbitos federal, estadual e municipal',
                            item: 8,
                            value: 8
                        },
                        { text: 'Comprovante de inscrição no CNPJ', item: 9, value: 9 },
                        {
                            text:
                                'Declaração do dirigente máximo acerca da inexistência de dívida com o poder público ou de inscrição da ORGANIZAÇÃO nos bancos de dados públicos ou privados de proteção ao crédito',
                            item: 10,
                            value: 10
                        },
                        {
                            text:
                                'Declaração, para fins do disposto no inciso V do art. 27 da lei nº 8.666, de 21 de junho de 1993, acrescido pela Lei nº 9.854, de 27 de outubro de 1999, de que não possui em seu quadro de pessoal empregado(s) com menos de 18 (dezoito) anos em trabalho noturno, perigoso ou insalubre e, em qualquer trabalho, menores de 16 (dezesseis) anos, salvo na condição de aprendiz a partir de 14 (quatorze) anos',
                            item: 11,
                            value: 11
                        },
                        { text: 'Demonstração do Resultado do Exercício – DRE', item: 12, value: 12 },
                        {
                            text:
                                'Documentação sobre parcerias (quando couber), tais como cartas de intenção, termos e/ou contratos de parceria. Essa documentação deve demonstrar a natureza da parceria (financeira, técnica, de recursos humanos, materiais e outros) e ser assinada pelos responsáveis legais de cada uma das entidades envolvidas',
                            item: 13,
                            value: 13
                        },
                        { text: 'Estatuto da Instituição', item: 14, value: 14 },
                        { text: 'Orçamento Físico-Financeiro', item: 15, value: 15 },
                        { text: 'Necessidade de apresentar orçamentos comparativos', item: 17, value: 17 },
                        { text: 'Projetos aprovados em leis de incentivo', item: 18, value: 18 },
                        {
                            text:
                                'Registro no respectivo Conselho Municipal dos Direitos da Criança e do Adolescente (exceto para aquelas organizações de Educação para o trabalho que atuem exclusivamente com jovens acima de 18 anos)',
                            item: 19,
                            value: 19
                        },
                        {
                            text: 'Resumo com o currículo (histórico de atuação) do responsável pelo projeto',
                            item: 20,
                            value: 20
                        },
                        { text: 'Vídeo da liderança se apresentando', item: 21, value: 21 },
                        { text: 'Cópia do CPF/RG dos atuais representantes legais/sócios', item: 24, value: 24 },
                        { text: 'Nenhum', item: 22, value: 22 },
                        { text: 'Outros', item: 23, value: 23 }
                    ]
                },
                hasProcess: {
                    selected: null,
                    options: []
                },
                hasMission: {
                    selected: null,
                    options: []
                },
                hasTeam: {
                    selected: null,
                    options: []
                },
                hasVision: {
                    selected: null,
                    options: []
                },
                hasValues: {
                    selected: null,
                    options: []
                },
                budget: {
                    selected: null,
                    options: []
                },
                financiallyMaintain: {
                    selected: [],
                    options: [
                        { text: 'Eu mesmo coloco grana', item: 1, value: 1, show: true },
                        { text: 'Participo de editais públicos', item: 2, value: 2, show: true },
                        { text: 'Faço campanhas de financiamento coletivo', item: 3, value: 3, show: true },
                        { text: 'Presto serviços', item: 4, value: 4, show: true },
                        { text: 'Faço eventos', item: 5, value: 5, show: true },
                        { text: 'Recebo recurso via leis de incentivo', item: 6, value: 6, show: true },
                        { text: 'Parceria com órgão público', item: 7, value: 7, show: true },
                        { text: 'Recebo recurso via nota fiscal paulista', item: 8, value: 8, show: true },
                        { text: 'Participo de editais de empresas', item: 9, value: 9, show: true },
                        { text: 'Tenho um mantenedor pessoa física', item: 10, value: 10, show: true },
                        {
                            text: 'Participo de editais de Fundações/Institutos/Fundos',
                            item: 11,
                            value: 11,
                            show: true
                        },
                        { text: 'Tenho um mantenedor pessoa jurídica', item: 12, value: 12, show: true },
                        { text: 'Participo de editais internacionais', item: 13, value: 13, show: true },
                        { text: 'Vendo produtos', item: 14, value: 14, show: true },
                        { text: 'Outros', item: 15, value: 15, show: true }
                    ]
                },
                socialImpact: {
                    selected: [],
                    options: [
                        { text: 'Melhoria das condições de saúde', item: 1, value: 1 },
                        { text: 'Melhorias em saneamento e/ou água', item: 2, value: 2 },
                        { text: 'Melhoria das condições educacionais', item: 3, value: 3 },
                        {
                            text: 'Redução dos custos de transação (crédito, compras, empreendimentos)',
                            item: 4,
                            value: 4
                        },
                        { text: 'Melhoria das condições de habitação', item: 5, value: 5 },
                        {
                            text: 'Proteção socioambiental de áreas rurais e comunidades tradicionais',
                            item: 6,
                            value: 6
                        },
                        { text: 'Melhoria das condições ambientais urbanas', item: 7, value: 7 },
                        {
                            text: 'Diminuição do risco da família cair em situações de pobreza extrema',
                            item: 8,
                            value: 8
                        },
                        { text: 'Melhorias no meio ambiente', item: 9, value: 9 },
                        { text: 'Proteção de Direitos Humanos', item: 11, value: 11 },
                        { text: 'Melhoria do protagonismo local', item: 12, value: 12 },
                        { text: 'Geração de emprego/renda', item: 13, value: 13 },
                        { text: 'Desenvolvimento comunitário', item: 14, value: 14 }
                    ]
                },
                hasCounter: {
                    selected: null,
                    options: []
                },
                reserveFund: {
                    selected: null,
                    options: []
                },
                hasFundRaising: {
                    selected: null,
                    options: []
                },
                hasFundTime: {
                    selected: null,
                    options: []
                },
                hasDebts: {
                    selected: null,
                    options: []
                },
                currentNetworks: {
                    selected: null,
                    options: []
                },
                currentPartners: {
                    selected: null,
                    options: []
                },
                hasMonitoringProcess: {
                    selected: null,
                    options: []
                },
                hasPerformanceIndications: {
                    selected: null,
                    options: []
                },
                isContemplatedMission: {
                    selected: null,
                    options: [
                        { text: 'Selecione', value: null },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                currentInitiativeStatus: {
                    selected: null,
                    options: []
                },
                origin: {
                    selected: null,
                    options: []
                },
                initiative: {
                    selected: null,
                    options: []
                },
                profession: {
                    selected: null,
                    options: []
                },
                maturityStage: {
                    selected: null,
                    options: []
                },
                monthlyInvoicing: {
                    selected: null,
                    options: []
                },
                initiativeYearCreated: null,
                hasAudit: {
                    selected: null,
                    options: [
                        { text: 'Selecione', value: null },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                hasCouncil: {
                    selected: null,
                    options: [
                        { text: 'Selecione', value: null },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                hasFiscalCouncil: {
                    selected: null,
                    options: [
                        { text: 'Selecione', value: null },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                hasRegister: {
                    selected: null,
                    options: [
                        { text: 'Selecione', value: null },
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform']),
        changeRegisterType() {
            this.filterForm.powerType.selected = null
        },
        changeState() {
            if (this.filterForm.state.selected !== null) {
                this.getCities(this.filterForm.state.selected)
            } else {
                this.filterForm.city.options = []
            }
        },
        filterData() {
            const data = {
                id_organizacao: this.filterForm.registerType.selected,
                prestador_servico: this.filterForm.powerType.selected,
                ods: this.filterForm.ods.selected,
                estado_desenvolve_acao: this.filterForm.state.selected,
                cidade_desenvolve_acao: this.filterForm.city.selected,
                id_formato_juridico: this.filterForm.legalConstitution.selected,
                possui_cnpj: this.filterForm.hasCnpj.selected,
                id_natureza_inicitiva: this.filterForm.origin.selected,
                id_iniciativa: this.filterForm.initiative.selected,
                principal_area_atuacao: this.filterForm.areas.selected,
                // sobre o responsavel legal
                id_genero: this.filterForm.gender.selected,
                id_raca: this.filterForm.color.selected,
                id_tempo_trabalha: this.filterForm.initiativeTime.selected,
                id_escolaridade: this.filterForm.scholarity.selected,
                possui_drt: this.filterForm.hasDrt.selected,
                id_tempo_dedicado: this.filterForm.dedicatedTime.selected,
                empreendeu_antes: this.filterForm.undertookBefore.selected,
                id_vocee: this.filterForm.profession.selected,
                // sobre a iniciativa
                tempo_iniciativa_existe: this.filterForm.initiativeYearCreated,
                dimensao_impacto_social: this.filterForm.socialImpact.selected,
                iniciativa_possuo_titulo: this.filterForm.titleQualification.selected,
                id_maturidade: this.filterForm.maturityStage.selected,
                segmento_mercado: this.filterForm.marketSegments.selected,
                tipo_produto: this.filterForm.productType.selected,
                tipo_servico: this.filterForm.serviceType.selected,
                aporte_financeiro: this.filterForm.financialSupport.selected,
                leis_incentivo: this.filterForm.laws.selected,
                projetos_aprovados: this.filterForm.approvedProjects.selected,
                organizacao_apoia_pp: this.filterForm.supportWays.selected,
                id_areaAbrangencia: this.filterForm.area.selected,
                id_atualmente: this.filterForm.currentInitiativeStatus.selected,
                id_publicoMotivador: this.filterForm.agePublic.selected,
                id_bioma: this.filterForm.biome.selected,
                considera_atuacao_iniciativa: this.filterForm.isInnovative.selected,
                id_estagio: this.filterForm.developmentStage.selected,
                id_percentual_colaborador: this.filterForm.womenQuantity.selected,
                ligada_algum_partido: this.filterForm.politicalConnection.selected,
                possou_tipo_acelerador: this.filterForm.hadAcceleration.selected,
                afiliacao_algum_igreja: this.filterForm.churchConnection.selected,
                distrito: this.filterForm.district.selected,
                id_categoria_financiadora: this.filterForm.financierCategory.selected,
                id_numero_colaborador: this.filterForm.employeesNumber.selected,
                tipos_iniciativas_sociais: this.filterForm.socialInitiativeTypes.selected,
                faixa_aporte_financeiro: this.filterForm.financialContributionRange.selected,
                maneira_acessar_oportunidade: this.filterForm.ways.selected,
                doc_iniciativa_solicita: this.filterForm.documents.selected,
                // planejamento e gestao
                iniciativaPlanejamento: this.filterForm.hasProcess.selected,
                missaoDefinida: this.filterForm.hasMission.selected,
                equipeComunicacao: this.filterForm.hasTeam.selected,
                visaoDefinida: this.filterForm.hasVision.selected,
                valoresDefinidos: this.filterForm.hasValues.selected,
                iniciativaPossui: this.filterForm.initiativeHas.selected,
                // sustentabilidade financeira
                id_orcamento_anual: this.filterForm.budget.selected,
                iniciativa_mantem: this.filterForm.financiallyMaintain.selected,
                possui_contador: this.filterForm.hasCounter.selected,
                possui_fundo_reserva: this.filterForm.reserveFund.selected,
                equipe_captacao_recurso: this.filterForm.hasFundRaising.selected,
                id_mantenha_atividade_tempo: this.filterForm.hasFundTime.selected,
                algum_endividamento: this.filterForm.hasDebts.selected,
                id_faturamento: this.filterForm.monthlyInvoicing.selected,
                // redes e parceiros
                id_atuais_parceiro: this.filterForm.currentPartners.selected,
                id_redes_faz_parte: this.filterForm.currentNetworks.selected,
                // resultados e impactos
                processo_monitoramento: this.filterForm.hasMonitoringProcess.selected,
                indicadores_desempenho: this.filterForm.hasPerformanceIndications.selected,
                // governanca
                organizacao_contemplada: this.filterForm.isContemplatedMission.selected,
                passa_por_auditoria: this.filterForm.hasAudit.selected,
                deliberativo_formalmente: this.filterForm.hasCouncil.selected,
                conselho_fiscal: this.filterForm.hasFiscalCouncil.selected,
                mantem_registro: this.filterForm.hasRegister.selected
            }

            this.setIsLoading(true)

            platformApi
                .filterConnectionSuggestions(data)
                .then(response => {
                    localStorage.setItem('filter-data', JSON.stringify(data))

                    if (response.data.result) {
                        const result = response.data.result
                        this.filterDataIds = result.map(item => item.id)
                    }

                    const resultMap = response.data.dataMapa
                    this.mapData = resultMap !== null && resultMap.length ? resultMap : []
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        fetch() {
            this.profileData = {
                starsNumber: 0,
                profileName: '',
                initiativeDescription: '',
                email: '',
                city: 'São Paulo - SP',
                partners: [],
                connectionsNumber: 0,
                evaluationNumber: 0,
                compatibility: 0,
                selectedStatus: [1, 2, 3, 4, 5, 6, 7, 8, 9]
            }

            this.getFilterDataLocalStorage()

            this.setIsLoading(true)

            axios
                .all([authenticationApi.getUser(), platformApi.listConnectionSuggestions()])
                .then(response => {
                    this.idUserLogged = response[0].data.id

                    if (response[1].data) {
                        const data = response[1].data.extra
                        this.starsNumber = data.estrela
                        this.connectionsNumber = data.conexao
                        this.evaluationNumber = data.avaliacao
                        this.initiativesNumber = data.iniciativa
                        this.serviceProvisionNumber = data.prestador_servico
                        this.investorsNumber = data.investidor
                    }

                    if (response[1].data.result.length) {
                        this.allConnections = []
                        this.allConnections.push(...response[1].data.result)
                        this.connections.push(...this.allConnections.slice(this.page * 6, (this.page + 1) * 6))

                        this.page += 1
                    }

                    const resultMap = response[1].data.dataMapa

                    if (resultMap !== null && resultMap.length) {
                        this.mapData = resultMap
                        this.mapDataAll = resultMap
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        infiniteHandler($state) {
            const data = this.allConnections.slice(this.page * 6, (this.page + 1) * 6)

            setTimeout(() => {
                if (data.length && this.page) {
                    this.connections.push(...data)
                    this.page += 1
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }, 500)
        },
        getFilterDataLocalStorage() {
            if (localStorage.getItem('filter-data')) {
                const data = JSON.parse(localStorage.getItem('filter-data'))

                this.filterForm.registerType.selected = data.id_organizacao
                this.filterForm.powerType.selected = data.prestador_servico
                this.filterForm.ods.selected = data.ods
                this.filterForm.state.selected = data.estado_desenvolve_acao
                this.filterForm.city.selected = data.cidade_desenvolve_acao
                this.filterForm.legalConstitution.selected = data.id_formato_juridico
                this.filterForm.hasCnpj.selected = data.possui_cnpj
                this.filterForm.origin.selected = data.id_natureza_inicitiva
                this.filterForm.initiative.selected = data.id_iniciativa
                this.filterForm.areas.selected = data.principal_area_atuacao
                // sobre o responsavel legal
                this.filterForm.gender.selected = data.id_genero
                this.filterForm.color.selected = data.id_raca
                this.filterForm.initiativeTime.selected = data.id_tempo_trabalha
                this.filterForm.scholarity.selected = data.id_escolaridade
                this.filterForm.hasDrt.selected = data.possui_drt
                this.filterForm.dedicatedTime.selected = data.id_tempo_dedicado
                this.filterForm.undertookBefore.selected = data.empreendeu_antes
                this.filterForm.profession.selected = data.id_vocee
                // sobre a iniciativa
                this.filterForm.initiativeYearCreated = data.tempo_iniciativa_existe
                this.filterForm.socialImpact.selected = data.dimensao_impacto_social
                this.filterForm.titleQualification.selected = data.iniciativa_possuo_titulo
                this.filterForm.maturityStage.selected = data.id_maturidade
                this.filterForm.marketSegments.selected = data.segmento_mercado
                this.filterForm.productType.selected = data.tipo_produto
                this.filterForm.serviceType.selected = data.tipo_servico
                this.filterForm.financialSupport.selected = data.aporte_financeiro
                this.filterForm.laws.selected = data.leis_incentivo
                this.filterForm.approvedProjects.selected = data.projetos_aprovados
                this.filterForm.supportWays.selected = data.organizacao_apoia_pp
                this.filterForm.area.selected = data.id_areaAbrangencia
                this.filterForm.currentInitiativeStatus.selected = data.id_atualmente
                this.filterForm.agePublic.selected = data.id_publicoMotivador
                this.filterForm.biome.selected = data.id_bioma
                this.filterForm.isInnovative.selected = data.considera_atuacao_iniciativa
                this.filterForm.developmentStage.selected = data.id_estagio
                this.filterForm.womenQuantity.selected = data.id_percentual_colaborador
                this.filterForm.politicalConnection.selected = data.ligada_algum_partido
                this.filterForm.hadAcceleration.selected = data.possou_tipo_acelerador
                this.filterForm.churchConnection.selected = data.afiliacao_algum_igreja
                this.filterForm.district.selected = data.distrito
                this.filterForm.financierCategory.selected = data.id_categoria_financiadora
                this.filterForm.employeesNumber.selected = data.id_numero_colaborador
                this.filterForm.socialInitiativeTypes.selected = data.tipos_iniciativas_sociais
                this.filterForm.financialContributionRange.selected = data.faixa_aporte_financeiro
                this.filterForm.ways.selected = data.maneira_acessar_oportunidade
                this.filterForm.documents.selected = data.doc_iniciativa_solicita
                // planejamento e gestao
                this.filterForm.hasProcess.selected = data.iniciativaPlanejamento
                this.filterForm.hasMission.selected = data.missaoDefinida
                this.filterForm.hasTeam.selected = data.equipeComunicacao
                this.filterForm.hasVision.selected = data.visaoDefinida
                this.filterForm.hasValues.selected = data.valoresDefinidos
                this.filterForm.initiativeHas.selected = data.iniciativaPossui
                // sustentabilidade financeira
                this.filterForm.budget.selected = data.id_orcamento_anual
                this.filterForm.financiallyMaintain.selected = data.iniciativa_mantem
                this.filterForm.hasCounter.selected = data.possui_contador
                this.filterForm.reserveFund.selected = data.possui_fundo_reserva
                this.filterForm.hasFundRaising.selected = data.equipe_captacao_recurso
                this.filterForm.hasFundTime.selected = data.id_mantenha_atividade_tempo
                this.filterForm.hasDebts.selected = data.algum_endividamento
                this.filterForm.monthlyInvoicing.selected = data.id_faturamento
                // redes e parceiros
                this.filterForm.currentPartners.selected = data.id_atuais_parceiro
                this.filterForm.currentNetworks.selected = data.id_redes_faz_parte
                // resultados e impactos
                this.filterForm.hasMonitoringProcess.selected = data.processo_monitoramento
                this.filterForm.hasPerformanceIndications.selected = data.indicadores_desempenho
                // governanca
                this.filterForm.isContemplatedMission.selected = data.organizacao_contemplada
                this.filterForm.hasAudit.selected = data.passa_por_auditoria
                this.filterForm.hasCouncil.selected = data.deliberativo_formalmente
                this.filterForm.hasFiscalCouncil.selected = data.conselho_fiscal
                this.filterForm.hasRegister.selected = data.mantem_registro
            }
        },
        clearFilterDataLocalStorage() {
            localStorage.removeItem('filter-data')
            this.filterDataIds = null
            this.mapData = [...this.mapDataAll]

            this.filterForm.registerType.selected = null
            this.filterForm.powerType.selected = null
            this.filterForm.ods.selected = []
            this.filterForm.state.selected = null
            this.filterForm.city.selected = null
            this.filterForm.legalConstitution.selected = null
            this.filterForm.hasCnpj.selected = null
            this.filterForm.origin.selected = null
            this.filterForm.initiative.selected = null
            this.filterForm.areas.selected = []
            // sobre o responsavel legal
            this.filterForm.gender.selected = null
            this.filterForm.color.selected = null
            this.filterForm.initiativeTime.selected = null
            this.filterForm.scholarity.selected = null
            this.filterForm.hasDrt.selected = null
            this.filterForm.dedicatedTime.selected = null
            this.filterForm.undertookBefore.selected = null
            this.filterForm.profession.selected = null
            // sobre a iniciativa
            this.filterForm.initiativeYearCreated = null
            this.filterForm.socialImpact.selected = []
            this.filterForm.titleQualification.selected = []
            this.filterForm.maturityStage.selected = null
            this.filterForm.marketSegments.selected = []
            this.filterForm.productType.selected = []
            this.filterForm.serviceType.selected = []
            this.filterForm.financialSupport.selected = []
            this.filterForm.laws.selected = []
            this.filterForm.approvedProjects.selected = []
            this.filterForm.supportWays.selected = []
            this.filterForm.area.selected = null
            this.filterForm.currentInitiativeStatus.selected = null
            this.filterForm.agePublic.selected = null
            this.filterForm.biome.selected = null
            this.filterForm.isInnovative.selected = null
            this.filterForm.developmentStage.selected = null
            this.filterForm.womenQuantity.selected = null
            this.filterForm.politicalConnection.selected = null
            this.filterForm.hadAcceleration.selected = null
            this.filterForm.churchConnection.selected = null
            this.filterForm.district.selected = null
            this.filterForm.financierCategory.selected = null
            this.filterForm.employeesNumber.selected = null
            this.filterForm.socialInitiativeTypes.selected = []
            this.filterForm.financialContributionRange.selected = null
            this.filterForm.ways.selected = []
            this.filterForm.documents.selected = []
            // planejamento e gestao
            this.filterForm.hasProcess.selected = null
            this.filterForm.hasMission.selected = null
            this.filterForm.hasTeam.selected = null
            this.filterForm.hasVision.selected = null
            this.filterForm.hasValues.selected = null
            this.filterForm.initiativeHas.selected = []
            // sustentabilidade financeira
            this.filterForm.budget.selected = null
            this.filterForm.financiallyMaintain.selected = []
            this.filterForm.hasCounter.selected = null
            this.filterForm.reserveFund.selected = null
            this.filterForm.hasFundRaising.selected = null
            this.filterForm.hasFundTime.selected = null
            this.filterForm.hasDebts.selected = null
            this.filterForm.monthlyInvoicing.selected = null
            // redes e parceiros
            this.filterForm.currentPartners.selected = null
            this.filterForm.currentNetworks.selected = null
            // resultados e impactos
            this.filterForm.hasMonitoringProcess.selected = null
            this.filterForm.hasPerformanceIndications.selected = null
            // governanca
            this.filterForm.isContemplatedMission.selected = null
            this.filterForm.hasAudit.selected = null
            this.filterForm.hasCouncil.selected = null
            this.filterForm.hasFiscalCouncil.selected = null
            this.filterForm.hasRegister.selected = null
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        openFilterModal() {
            let idUser = null

            if (localStorage.getItem('usuario')) {
                idUser = JSON.parse(localStorage.getItem('usuario')).id
            }

            this.setIsLoading(true)

            axios
                .all([
                    platformApi.getAllProfileData(idUser),
                    registerFirstInformationApi.getOrganizationType(),
                    registerFirstInformationApi.getStates(),
                    registerFirstInformationApi.getLegalFormat(),
                    aboutLegalGuardianApi.getGender(),
                    aboutLegalGuardianApi.getRace(),
                    aboutLegalGuardianApi.getEducationLevel(),
                    aboutLegalGuardianApi.getDedicatedTime(),
                    aboutLegalGuardianApi.getWorkingTime(),
                    aboutInitiativeApi.getArea(),
                    aboutInitiativeApi.getMotivatingAudience(),
                    aboutInitiativeApi.getBiome(),
                    aboutInitiativeApi.getDevelopmentStage(),
                    aboutInitiativeApi.getEmployeePercentage(),
                    financialSustainabilityApi.getOrcamentoAnual(),
                    financialSustainabilityApi.getMantenhaAtividade(),
                    registerFirstInformationApi.getInitiativeNature(),
                    registerFirstInformationApi.getInitiativeType(),
                    aboutLegalGuardianApi.getYouAre(),
                    aboutInitiativeApi.getMaturity(),
                    financialSustainabilityApi.getFaturamentoMensal(),
                    aboutInitiativeApi.getCurrentlyInitiative(),
                    aboutInitiativeApi.getDistrict(),
                    aboutInitiativeApi.getFinancialCategory(),
                    aboutInitiativeApi.getCollaboratorNumber()
                ])
                .then(response => {
                    if (response[0].data.data) {
                        const result = response[0].data.data
                        this.allowFilterData.PrimeirasInformacao = result.PrimeirasInformacao !== null
                        this.allowFilterData.ResponsavelLegal = result.ResponsavelLegal !== null
                        this.allowFilterData.SobreOrganizacao = result.SobreOrganizacao !== null
                        this.allowFilterData.PlanejamentoGestao = result.PlanejamentoGestao !== null
                        this.allowFilterData.SustentabilidadeFinanceira = result.SustentabilidadeFinanceira !== null
                        this.allowFilterData.RedesParceiro = result.RedesParceiro !== null
                        this.allowFilterData.ResultadoImpacto = result.ResultadoImpacto !== null
                        this.allowFilterData.Governanca = result.Governanca !== null
                        this.allowFilterData.Anexos = result.Anexos !== null
                    }

                    this.filterForm.registerType.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[1].data.map(item => ({ value: item.id, text: item.organizacao }))
                    ]

                    this.filterForm.state.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[2].data.map(item => ({ value: item.id, text: item.estado, uf: item.uf }))
                    ]

                    this.filterForm.legalConstitution.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[3].data.map(item => ({ value: item.id, text: item.formato }))
                    ]

                    this.filterForm.gender.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[4].data.map(item => ({ value: item.id, text: item.genero }))
                    ]

                    this.filterForm.color.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[5].data.map(item => ({ value: item.id, text: item.raca }))
                    ]

                    this.filterForm.scholarity.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[6].data.map(item => ({ value: item.id, text: item.escolaridade }))
                    ]

                    this.filterForm.dedicatedTime.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[7].data.map(item => ({ value: item.id, text: item.tempo_dedicado }))
                    ]

                    this.filterForm.initiativeTime.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[8].data.map(item => ({ value: item.id, text: item.tempo_trabalha }))
                    ]

                    this.filterForm.area.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[9].data.map(item => ({ value: item.id, text: item.area_abrangencia }))
                    ]

                    this.filterForm.agePublic.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[10].data.map(item => ({ value: item.id, text: item.publico_motivador }))
                    ]

                    this.filterForm.biome.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[11].data.map(item => ({ value: item.id, text: item.bioma }))
                    ]

                    this.filterForm.developmentStage.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[12].data.map(item => ({ value: item.id, text: item.estagio }))
                    ]

                    this.filterForm.womenQuantity.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[13].data.map(item => ({ value: item.id, text: item.percentual_colaborador }))
                    ]

                    this.filterForm.budget.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[14].data.map(item => ({ value: item.id, text: item.orcamento_anual }))
                    ]

                    this.filterForm.hasFundTime.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[15].data.map(item => ({ value: item.id, text: item.tempo }))
                    ]

                    this.filterForm.origin.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[16].data.map(item => ({ value: item.id, text: item.natureza }))
                    ]

                    this.filterForm.initiative.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[17].data.map(item => ({ value: item.id, text: item.iniciativa }))
                    ]

                    this.filterForm.profession.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[18].data.map(item => ({ value: item.id, text: item.voce }))
                    ]

                    this.filterForm.maturityStage.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[19].data.map(item => ({ value: item.id, text: item.maturidade }))
                    ]

                    this.filterForm.monthlyInvoicing.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[20].data.map(item => ({ value: item.id, text: item.faturamento }))
                    ]

                    this.filterForm.currentInitiativeStatus.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[21].data.map(item => ({ value: item.id, text: item.atualmente }))
                    ]

                    this.filterForm.district.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[22].data.map(item => ({ value: item.id, text: item.distrito }))
                    ]

                    this.filterForm.financierCategory.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[23].data.map(item => ({ value: item.id, text: item.categoria_financiadora }))
                    ]

                    this.filterForm.employeesNumber.options = [
                        ...[{ value: null, text: 'Selecione' }],
                        ...response[24].data.map(item => ({ value: item.id, text: item.numero_colaborador }))
                    ]

                    this.showModal('opportunity-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))

            this.filterForm.hasCnpj.options = this.filterForm.isInnovative.options = this.filterForm.politicalConnection.options = this.filterForm.hadAcceleration.options = this.filterForm.churchConnection.options = this.filterForm.hasProcess.options = this.filterForm.hasMission.options = this.filterForm.hasTeam.options = this.filterForm.hasVision.options = this.filterForm.hasValues.options = this.filterForm.hasCounter.options = this.filterForm.reserveFund.options = this.filterForm.hasFundRaising.options = this.filterForm.hasDebts.options = this.filterForm.currentPartners.options = this.filterForm.currentNetworks.options = this.filterForm.hasMonitoringProcess.options = this.filterForm.hasPerformanceIndications.options = [
                { value: null, text: 'Selecione' },
                { value: 1, text: 'Sim' },
                { value: 0, text: 'Não' }
            ]
        },
        getCities(stateId) {
            this.loadCities = true
            const uf = this.filterForm.state.options.filter(item => item.value === stateId)[0].uf

            registerFirstInformationApi.getCities(uf).then(res => {
                const cities = [{ value: null, text: 'Selecione' }].concat(
                    res.data.map(item => ({ value: item.id, text: item.cidade }))
                )
                this.filterForm.city.options = cities

                if (!cities.includes(this.filterForm.city.selected)) {
                    this.filterForm.city.selected = null
                }
                this.loadCities = false
            })
        },
        backFromSeeProfile() {
            this.changeRegisterForm('FirstInformationForm1')
            this.profileData = {}
            this.showProfileData = false
            this.fetch()
        },
        getOrganizationProfile(data) {
            if (data.id_organizacao === 1 && data.prestador_servico === 0) {
                return 'Iniciativa'
            } else if (data.id_organizacao === 1 && data.prestador_servico) {
                return 'Prestador de Serviço'
            } else if (data.id_organizacao === 2) {
                return 'Investidor'
            }
        },
        setShowProfileData(data) {
            this.myProfileTitle = `Perfil da organização (${this.getOrganizationProfile(data)})`

            this.changeRegisterForm('FirstInformationForm1')

            this.setIsLoading(true)

            platformApi
                .getAllProfileData(data.id_user)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data

                        this.profileData.allData = data
                        this.profileData.starsNumber = data.Estrela
                        this.profileData.email = data.PrimeirasInformacao.email
                        this.profileData.profileName = data.PrimeirasInformacao.nome_organizacao
                        this.profileData.initiativeDescription = data.PrimeirasInformacao.descricao_organizacao
                        this.profileData.partners = data.PrimeirasInformacao.ods
                        this.profileData.connectionsNumber = data.Conexao
                        this.profileData.evaluationNumber = data.TotalAvaliacao
                        this.profileData.compatibility = data.Compatibilidade
                        this.profileData.idUserLogged = this.idUserLogged
                        this.showProfileData = true

                        if (data.SobreOrganizacao) {
                            this.profileData.city = `${data.SobreOrganizacao.cidade} - ${data.SobreOrganizacao.estado}`
                        } else {
                            this.profileData.city = ''
                        }

                        this.scrollBehavior()
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
        },
        scrollBehavior() {
            const ele = document.getElementById('app')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getMyProfileTitle() {
            return this.myProfileTitle
        },
        getProfileData() {
            return this.profileData
        },
        getProgress() {
            return Number(this.getProfileData.allData['PrimeirasInformacao'].percentual)
        },
        getFilterDataIds() {
            return this.filterDataIds
        },
        getStarsNumber() {
            return Math.round(this.starsNumber)
        },
        getAllowExport() {
            return this.$store.state.allowExportBtn
        },
        getAllowFilterData() {
            return this.allowFilterData
        },
        getConnections() {
            if (this.getFilterDataIds !== null) {
                if (this.getFilterDataIds.length) {
                    return this.connections.filter(item => this.getFilterDataIds.includes(item.id))
                } else {
                    return []
                }
            } else {
                return this.connections
            }
        }
    },
    mounted() {
        this.fetch()
    }
}
</script>

<style scope src="./OpportunityPanel-light-theme.css"></style>
<style scope src="./OpportunityPanel-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/opportunity-panel/OpportunityPanel.vue